import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Field, reduxForm } from 'redux-form';
import { Link } from 'react-router-dom';
import ScrollArea from 'react-scrollbar';

import BackIcon from 'material-ui/svg-icons/navigation/arrow-back';

import { Section, SectionItem } from '../../components/basic/section';
import Button from '../../components/basic/Button';
import TextField from '../../components/basic/TextField';
import SelectField from '../../components/basic/SelectField';

import * as teamsActions from '../../actions/entities/TeamsActions';
import * as companyActions from '../../actions/entities/CompanyActions';
import * as Validators from '../../services/Validators';

// import '../forms/Form.css';

const minLength1 = Validators.minLength(1);

class TeamContainer extends Component {
  componentDidMount() {
    const { match, fetchTeam, resetCurrentTeam, fetchCompanies } = this.props;
    const { teamId } = match.params;

    // Load companies for the dropdown
    fetchCompanies();

    if (teamId === 'new') {
      resetCurrentTeam();
    } else {
      fetchTeam(teamId);
    }
  }

  componentWillReceiveProps(nextProps) {
    const { match } = nextProps;
    const { teamId } = match.params;

    if (teamId !== this.props.match.params.teamId) {
      if (teamId === 'new') {
        this.props.resetCurrentTeam();
      } else {
        this.props.fetchTeam(teamId);
      }
    }
  }

  handleSubmit = values => {
    const { match, updateTeam, createTeam, currentTeam } = this.props;
    const { teamId } = match.params;
    const isNew = teamId === 'new';

    const { name, echoPulsePromptContextEN } = values;
    const data = currentTeam.data || {};
    const payload = {
      ...currentTeam,
      name,
      data: {
        ...data,
        promptContext: {
          ...(data.promptContext || {}),
          en: { ...((data.promptContext && data.promptContext.en) || {}), echoPulse: echoPulsePromptContextEN }
        }
      }
    };
    if (isNew) {
      createTeam(payload);
    } else {
      updateTeam(payload);
    }
  };

  render() {
    const { handleSubmit, currentTeam, currentTeamSaving } = this.props;
    const isNew = !currentTeam.id;

    return (
      <form className="Form" onSubmit={handleSubmit(this.handleSubmit)}>
        <ScrollArea>
          <div className="Form-content-container">
            <div className="container">
              <div className="row">
                <div className="col-sm-12">
                  <Section title="Team Information">
                    <SectionItem contentStyle={{ paddingTop: 0 }}>
                      <Field
                        name="name"
                        component={TextField}
                        label="Name"
                        fullWidth
                        validate={[Validators.required, minLength1]}
                      />
                    </SectionItem>
                  </Section>

                  <Section title="Echo Pulse Settings">
                    <SectionItem>
                      <Field
                        name="echoPulsePromptContextEN"
                        component={TextField}
                        multiLine
                        rows={5}
                        label="Echo Pulse prompt context"
                        helperText="Custom team-wide prompt context for Echo Pulse"
                        fullWidth
                      />
                    </SectionItem>
                  </Section>
                </div>
              </div>
            </div>
          </div>
        </ScrollArea>
        <div className="Form-buttons-container">
          <div className="Form-buttons clearfix">
            <div className="float-left" style={{ fontSize: 0 }}>
              <Button
                label="Back"
                icon={<BackIcon />}
                style={{ fontSize: '16px' }}
                containerElement={<Link to="/settings/teams" />}
              />
            </div>
            <div className="float-right">
              <Button raised primary label={isNew ? 'Create' : 'Save'} type="submit" loading={currentTeamSaving} />
            </div>
          </div>
        </div>
      </form>
    );
  }
}

const mapStateToProps = state => {
  const { teams } = state.entities;
  const team = teams.currentTeam;
  return {
    currentTeam: team,
    currentTeamSaving: teams.currentTeamSaving,
    initialValues: {
      name: team ? team.name : '',
      echoPulsePromptContextEN:
        (team &&
          team.data &&
          team.data.promptContext &&
          team.data.promptContext.en &&
          team.data.promptContext.en.echoPulse) ||
        ''
    }
  };
};

export default connect(mapStateToProps, { ...teamsActions, ...companyActions })(
  reduxForm({
    form: 'team',
    enableReinitialize: true
  })(TeamContainer)
);



// WEBPACK FOOTER //
// ./src/containers/private/TeamContainer.js